<template>
	<form class="form form--has-fixed-group" novalidate>
		<div ref="success" v-show="success" class="alert alert--success">
			{{ currentUser ? 'Your specialisations have been saved' : 'User specialisation have been updated' }}
		</div>

		<fieldset class="form__group">
			<legend>Follow up to four sectors you specialise in:</legend>

			<ListSectors :depth="1" :counts="false" :children="true">
				<template slot="actions" slot-scope="{ sector }">
					<input :id="`specialise-${sector.id}`" class="toggle" name="specialisms" type="checkbox"
					       v-model="formData.specialisms" :value="sector.id"/>
					<label :for="`specialise-${sector.id}`" class="toggle">
						{{ formData.specialisms.indexOf(sector.id) > -1 ? 'Deselect' : 'Select' }}
					</label>
				</template>
			</ListSectors>
		</fieldset>

		<div class="form__group form__group--submit-fixed">
			<button class="btn btn--primary" @click.prevent="submit"
			        v-wait:disabled="waitName">Save Changes</button>
		</div>
	</form>
</template>

<script>
	import API from './../../../api';
	import ListSectors from '../../List/ListSectors';
	import UserFormTab from './UserFormTab';

	export default {
		name: 'UserFormSpecialisedSectors',
		mixins: [UserFormTab],
		components: {
			ListSectors,
		},
		data() {
			return {
				waitName: 'updateSpecialisms',
				formData: {
					specialisms: []
				},
			};
		},
		methods: {
			save() {
				return API.updateUserSpecialisms(this.id, this.formData.specialisms);
			},
		}
	}
</script>
